export * from './adapter';
//# sourceMappingURL=index.js.map